(function ($) {
  $(function () {
    var $videoCardGrid = $(".video-card-grid");

    if ($videoCardGrid.length) {
      var videoCardGrid = (function () {
        var $blogCards = $(".video-card-grid .card-wrapper");
        var $pagination = $(".pagination");
        var blogPerPage = 15;
        var numProductCards = $blogCards.length;

        function initPagination() {
          if (numProductCards > blogPerPage) {
            $blogCards
              .addClass("show")
              .slice(blogPerPage)
              .addClass("hide");

            $pagination.pagination({
              items: numProductCards,
              itemsOnPage: blogPerPage,
              onPageClick: function (pageNumber) {
                switchPage(pageNumber);
                smoothScrollTo($videoCardGrid);
              },
            });
            if (window.location.hash && window.location.hash.substring(1).includes('page-')) {
              var pageNumber = window.location.hash.substring(1).replace('page-', '');
              var totalPagesCount = $pagination.pagination('getPagesCount');

              if (pageNumber > 0 && pageNumber <= totalPagesCount) {
                $pagination.pagination('drawPage', pageNumber);
                switchPage(pageNumber);
              }
            }
          } else {
            $pagination.addClass("hide");
          }
        }

        function switchPage(pageNumber) {
          var showFrom = blogPerPage * (pageNumber - 1);
          var showTo = showFrom + blogPerPage;

          $blogCards.addClass('hide');
          $blogCards.filter('.show').slice(showFrom, showTo).removeClass('hide');
        }

        function smoothScrollTo($offset) {
          if ($offset.length) {
            $('html, body').animate(
              {
                scrollTop: $offset.offset().top - $('.navigation').outerHeight(),
              },
              700,
              'linear'
            );
          }
        }

        return {
          init: function () {
            initPagination();
          },
        };
      })();

      videoCardGrid.init();
    }
  });
})(jQuery);
